import React from 'react'
import PropTypes from 'prop-types'
import AccordionSection from './AccordionSection'
import { Flags } from 'react-feature-flags'

export default class Accordion extends React.Component {
    render() {
        return (
            <div className="accordion">
                {this.props.content.map(({ id, heading, stagingOnly, count, body, initiallyClosed, open, onClick }) => (
                    <React.Fragment key={id}>
                        {/* Leaving this in to filter out new layers going forward (add `access: staging` in config.js) */}
                        <Flags authorizedFlags={stagingOnly ? ['staging'] : ['live']}>
                            <AccordionSection
                                heading={heading}
                                count={count}
                                body={body}
                                initiallyClosed={initiallyClosed}
                                open={open}
                                onClick={onClick}
                            />
                        </Flags>
                    </React.Fragment>
                ))}
            </div>
        )
    }
}

Accordion.propTypes = {
    content: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            ...AccordionSection.propTypes
        })
    ).isRequired
}
